module.exports = __webpack_public_path__ + "static/media/stack_table_view_dark.8b3fcb52.svg";